import { FeatureFlagName, STORAGE_KEY } from './useFeatureFlags'

/**
 * Reusable feature flag check function that can be used outside of React components
 * This function checks localStorage directly to avoid hook usage restrictions
 */
export const hasFeatureFlag = (flagName: FeatureFlagName): boolean => {
  try {
    const featureFlags = localStorage.getItem(STORAGE_KEY)

    if (featureFlags) {
      const parsed = JSON.parse(featureFlags)

      // Handle the nested structure: {state: {flags: {...}}, version: 0}
      const flags = parsed.state?.flags || parsed

      return flags[flagName] === true
    }
  } catch (_error) {
    // Silently fail - feature flag check failed
  }
  return false
}
